import React from "react";
import {Card, CardContent, TextField, Tooltip, Typography} from "@mui/material";
import {Error, Info, Warning} from "@mui/icons-material";
import { DocumentAudit } from "../../models/DocumentAudit";
import { AuditSeverity } from "../../models/AuditSeverity";
import moment from "moment";
import {DataGridPro, GridRenderCellParams} from "@mui/x-data-grid-pro";
import {translateFunction} from "../../../../localization/TranslationService";
const translate = translateFunction("SureBaseDocuments");
interface IAuditCardProps {
	audits: DocumentAudit[];
}

export const AuditCard: React.FC<IAuditCardProps> = ({ audits }) => {
	return (
		<Card>
			<CardContent>
				<Typography variant="h6" component="div">
					Audit Logs
				</Typography>
				<DataGridPro
					getRowId={(row: any) =>  row.id + row.timeStamp}
					columns={[
						{
						
							field: "severity",
							headerName: translate("Severity"),
							width: 100,
							renderCell: (params: GridRenderCellParams) => {
								return (
									<Tooltip title={params.row.severity}>
										{params.row.severity === AuditSeverity.Information ? (
											<Info color="info" />
										) : params.row.severity === AuditSeverity.Warning ? (
											<Warning color="warning" />
										) : (
											<Error color="error" />
										)}
									</Tooltip>
								);
							},

						},
						{
							field: "timeStamp",
							headerName: translate("Time"),
							width: 150,
							renderCell: (params: GridRenderCellParams) => {
								return (
									<>
										{params.row.timeStamp &&
										moment(params.row.timeStamp).format("DD-MM-YYYY HH:mm:ss")}
									</>
								);
							},
						},
						{
							field: "userIdentifier",
							headerName: translate("User"),
							width:200
						},
						{
							field: "message",
							headerName: translate("Message"),
							width:700,
							sortable: false,
							resizable: true,
							renderCell: (cellValues) => {
								return (

									<TextField
										fullWidth={true}
										value={cellValues.row.message}
										//									InputProps={{ disableUnderline: true }}
										multiline
										maxRows={2}
									/>

								);
							}
						},

					]} rows={audits}
					autoPageSize={true}
					
				/>
			</CardContent>
		</Card>
	);
};
